import Vue from 'vue'
import App from './App.vue'

//简易版
// import getSimple from "@/constants/simple";
// getSimple().then(res => {
//     // Vue.prototype.isSimple = false
//     // console.log('isSimple',res);
//     if(typeof(res) !== "undefined"){
//         Vue.prototype.isSimple = res
//     }else{
//         Vue.prototype.isSimple = true
//     }
// })
if (typeof(localStorage.getItem('isSimple')) == "string") {
    Vue.prototype.isSimple = JSON.parse(localStorage.getItem('isSimple'))
} else {
    if(localStorage.getItem('isSimple')){
        Vue.prototype.isSimple = localStorage.getItem('isSimple')
    }
}
if (typeof(localStorage.getItem('isCustom')) == "string") {
    Vue.prototype.isCustom = JSON.parse(localStorage.getItem('isCustom'))
} else {
    if(localStorage.getItem('isCustom')){
        Vue.prototype.isCustom = localStorage.getItem('isCustom')
    }
}
if (localStorage.getItem('customColor')) {
    Vue.prototype.customColor = localStorage.getItem('customColor')
} else {
    Vue.prototype.customColor = ''
}
if (localStorage.getItem('custom')) {
    Vue.prototype.custom = localStorage.getItem('custom')
} else {
    Vue.prototype.custom = ''
}

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
  
Vue.use(VideoPlayer)

import { createRouter } from "./router";

import { createStore } from "@/store";

// import router from './router'
// import store from './store'

import SlideVerify from 'vue-monoplasty-slide-verify'
Vue.use(SlideVerify)

import VueDND from 'awe-dnd';
// 注册-拖拽组件
Vue.use(VueDND);


import md5 from 'js-md5'
Vue.prototype.$md5 = md5;

//移动端UI组件库
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 为了实现Class的私有属性
// const showMessage = Symbol('showMessage')

// class DonMessage {
//   success (options, single = true) {
//     this[showMessage]('success', options, single)
//   }
//   warning (options, single = true) {
//     this[showMessage]('warning', options, single)
//   }
//   info (options, single = true) {
//     this[showMessage]('info', options, single)
//   }
//   error (options, single = true) {
//     this[showMessage]('error', options, single)
//   }

//   [showMessage] (type, options, single) {
//     if (single) {
//       // 判断是否已存在Message
//       if (document.getElementsByClassName('el-message').length === 0) {
//         Message[type](options)
//       }
//     } else {
//       Message[type](options)
//     }
//   }
// }


// Vue.prototype.$message = new DonMessage()





import echarts from 'echarts'
import axios from 'axios'
import "./plugins/index";
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.bus = new Vue({
    data() {
        return {
            // 定义数据
            val: true
        }
    },
})
Vue.use(ElementUI);
// 内容复制到剪贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


//自定义拖动
Vue.directive('drag',
    function(el, binding) {

        if (binding.value) {
            console.log(binding.value);
            let oDiv = el; //当前元素
            oDiv.onmousedown = function(e) {
                e.preventDefault();
                let bw = document.body.clientWidth;
                let bh = document.body.clientHeight;
                //鼠标按下，计算当前元素距离可视区的距离
                let disX = e.clientX - oDiv.offsetLeft;
                let disY = e.clientY - oDiv.offsetTop;
                // 计算两边坐标
                document.onmousemove = function(e) {
                    let l = 0,
                        t = 0;
                    // 拖动边界
                    if (e.clientX >= bw) {
                        l = bw - disX;
                    } else if (e.clientX <= 0) {
                        {
                            l = 0 - disX;
                        }
                    } else {
                        l = e.clientX - disX;
                    }
                    if (e.clientY >= bh) {
                        t = bh - disY;
                    } else if (e.clientY <= 0) {
                        t = 0 - disY;
                    } else {
                        t = e.clientY - disY;
                    }
                    //移动当前元素
                    oDiv.style.left = l + 'px';
                    oDiv.style.top = t + 'px';
                };
                // 鼠标停止移动时，事件移除
                document.onmouseup = function(e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            };
        } else {
            let oDiv = el; //当前元素
            oDiv.onmousedown = function(e) {
                e.preventDefault();
                // 鼠标停止移动时，事件移除
                document.onmouseup = function(e) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            };
        }
    }
);



import progressive from 'progressive-image/dist/vue'; // 渐进式
Vue.use(progressive, {
    removePreview: true,
    scale: true
})

import VueLazyLoad from 'vue-lazyload'; // 懒加载
Vue.use(VueLazyLoad, {
    error: require('@/assets/house/onloadpicerror.png'), // 加载错误的图片
    loading: require('@/assets/house/onloadpicin.png'), // 加载时的图片
    listenEvents: ['scroll', 'mousewheel']
});


// 导出一个工厂函数，用于创建新的
// 应用程序、router 和 store 实例
export function createApp() {
    const router = createRouter();
    const store = createStore();
    const app = new Vue({
        router,
        store,
        // 根实例简单的渲染应用程序组件。
        render: h => h(App)
    })
    return { app, router, store }
}

// new Vue({
//     router,
//     store,
//     render: h => h(App)
// }).$mount('#app')